<template>
	<v-form v-model="valid" v-if="form">
		<div>
			<div class="font-12 grey--text text--darken-2 font-weight-bold">
				{{ $vuetify.lang.t('$vuetify.views.groups.dialogs.createGroup.avatar') }}
			</div>
			<div class="d-flex mt-3 mb-5">
				<div>
					<avatar xxl :group="form" />
				</div>
				<div class="pl-5 pt-4">
					<attach-image-dialog
						@selected="setAvatar"
						ref="avatar-dialog"/>
					<v-btn
						color="accent"
						elevation="0"
						@click="showAvatarDialog()"
						class="font-12"
					>
						<v-icon class="mr-2">$add-image</v-icon>
						<template v-if="!form.avatar">
							{{ $vuetify.lang.t('$vuetify.views.groups.dialogs.createGroup.form.addAvatar') }}
						</template>
						<template v-else>
							{{ $vuetify.lang.t('$vuetify.views.groups.dialogs.createGroup.form.changeAvatar') }}
						</template>
					</v-btn>
					<v-btn
						v-if="form.avatar"
						class="ml-2"
						elevation="0"
						@click="removeAvatar()"
					>
						{{ $vuetify.lang.t('$vuetify.delete') }}
					</v-btn>
					<div class="grey--text my-3 font-12">
						{{ $vuetify.lang.t('$vuetify.views.groups.dialogs.createGroup.form.addAvatarDesc') }}
					</div>
					<v-btn
						v-if="!form.id"
						color="accent lighten-2"
						class="accent--text font-12"
						elevation="0"
						style="pointer-events: none"
					>
						<v-icon class="mr-2">$info</v-icon> {{ $vuetify.lang.t('$vuetify.views.groups.dialogs.createGroup.form.addAvatarInfo') }}
					</v-btn>
				</div>
			</div>
		</div>
		<div>
			<div :class="subheaderClasses">
				{{ $vuetify.lang.t('$vuetify.views.groups.dialogs.createGroup.name') }}
			</div>
			<v-text-field
				v-model="form.name"
				:placeholder="$vuetify.lang.t('$vuetify.views.groups.dialogs.createGroup.form.name')"
				outlined
				dense
				hide-details
				maxlength="50"
			></v-text-field>
			<div :class="charactersCountClasses">
				<template v-if="form.description">
					{{ form.name.length }}
				</template>
				<template v-else>0</template>
				/ 50 {{ $vuetify.lang.t('$vuetify.views.groups.dialogs.createGroup.form.characters') }}
			</div>
		</div>
		<div>
			<div :class="subheaderClasses">
				{{ $vuetify.lang.t('$vuetify.views.groups.dialogs.createGroup.description') }}
			</div>
			<v-textarea
				v-model="form.description"
				:placeholder="$vuetify.lang.t('$vuetify.views.groups.dialogs.createGroup.form.description')"
				outlined
				height="100"
				hide-details
				maxlength="1000"
			></v-textarea>
			<div :class="charactersCountClasses">
				<template v-if="form.description">
					{{ form.description.length }}
				</template>
				<template v-else>0</template>
				/ 1000 {{ $vuetify.lang.t('$vuetify.views.groups.dialogs.createGroup.form.characters') }}
			</div>
		</div>
		<div>
			<div :class="subheaderClasses">
				{{ $vuetify.lang.t('$vuetify.views.groups.dialogs.createGroup.type') }}
			</div>
			<v-radio-group v-model="form.is_public">
				<v-radio
					class="align-start"
					v-for="n in publicOptions"
					:key="n.value"
					:label="n.text"
					:value="n.value"
					:ripple="false"
				>
					<template slot="label">
						<div>
							<div class="grey--text text--darken-1 mb-2 font-weight-bold" style="margin-top: 2px;">
								{{ n.text }}
							</div>
							<div class="font-12">
								{{ n.description }}
							</div>
							<div v-if="!n.value && !form.is_public" class="mt-2">
								<custom-switch
									v-model="form.is_hide"
									:label="$vuetify.lang.t('$vuetify.views.groups.dialogs.createGroup.form.isHide')"
									sm
								/>
							</div>
						</div>
					</template>
				</v-radio>
			</v-radio-group>
		</div>
		<div v-if="!form.id">
			<div :class="subheaderClasses">
				{{ $vuetify.lang.t('$vuetify.views.groups.dialogs.createGroup.permissions') }}
			</div>
			<group-form-switches :form="form" />
		</div>
	</v-form>
</template>

<script>
import CustomSwitch from "@/components/items/CustomSwitch";
import Avatar from "@/components/Avatar";
import AttachImageDialog from "@/components/wall/dialogs/AttachImageDialog";
import GroupFormSwitches from "@/components/group/GroupFormSwitches";

export default {
	name: "GroupForm",
	components: {
		CustomSwitch,
		Avatar,
		AttachImageDialog,
		GroupFormSwitches
	},
	data () {
		return {
			valid: true,
			form: {
				name: '',
				description: '',
				is_public: true,
				is_hide: false,
				is_join_allowed: true,
				is_invitations_allowed: true,
				avatar_token: null,
				background_token: null,
				avatar: null
			},
			subheaderClasses: 'font-12 grey--text text--darken-2 font-weight-bold mb-2',
			charactersCountClasses: 'text-end mt-1 font-12 grey--text font-weight-bold',
			publicOptions: [
				{
					value: true,
					text: this.$vuetify.lang.t('$vuetify.views.groups.dialogs.createGroup.form.public'),
					description: this.$vuetify.lang.t('$vuetify.views.groups.dialogs.createGroup.form.publicDescription')
				},
				{
					value: false,
					text: this.$vuetify.lang.t('$vuetify.views.groups.dialogs.createGroup.form.private'),
					description: this.$vuetify.lang.t('$vuetify.views.groups.dialogs.createGroup.form.privateDescription')
				}
			]
		}
	},
	watch: {
		form: {
			handler(val) {
				this.$emit('input', val)
			},
			deep: true,
			immediate: true
		}
	},
	created() {
		if (this.$attrs.value) {
			let form = Object.assign({}, this.$attrs.value)
			// if (!form.background) {
			// 	form.background = ''
			// }
			this.form = form
		}
	},
	methods: {
		clearForm() {
			this.form = Object.assign({}, {
				name: '',
				description: '',
				is_public: true,
				is_hide: false,
				is_join_allowed: true,
				is_invitations_allowed: true,
				avatar_token: null,
				background_token: null,
				avatar: null
			})
		},
		showAvatarDialog() {
			this.$refs['avatar-dialog'].showDialog()
		},
		setAvatar(img) {
			this.form.avatar = {
				url: img
			}
		},
		removeAvatar() {
			this.form.avatar = null
			this.form.avatar_token = null
			if (this.form.id)
				this.form.delete_avatar = true
		}
	}
}
</script>
